import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { uiIcons } from '@/shared/brandIcons.js'

define('RegisterCTA', () => {
    return h('section', { className: 'register-cta' },
        h('div', { className: 'register-cta__inner' },
            h('div', { className: 'register-cta__content' },
                h('h2', { className: 'register-cta__headline' },
                    '¿Tienes un negocio en Fusagasuga?'
                ),
                h('p', { className: 'register-cta__desc' },
                    'Registra tu negocio en UBIYAAA y conecta con miles de clientes locales. Publica promociones, muestra tu catalogo y aparece en el directorio.'
                ),
                h('div', { className: 'register-cta__actions' },
                    h('a', {
                        className: 'register-cta__btn register-cta__btn--primary',
                        href: '/registrar',
                        innerHTML: uiIcons.clipboard + ' Registrar mi negocio' }),
                    h('a', {
                        className: 'register-cta__btn register-cta__btn--outline',
                        href: '/contacto',
                        innerHTML: uiIcons.whatsapp + ' Contactanos' })
                )
            ),
        )
    )
})
